import moment from "moment-timezone";
import { Moment } from "moment";
import { zonedTimeToUtc } from "date-fns-tz";

export function getCurrentMomentInZone(timeZone: string): Moment {
	return moment.tz(timeZone);
}

export function getTimeMomentInZone(time: string, timeZone: string): Moment {
	return moment.tz(time, timeZone);
}

export function getLocalMomentInZone(timeZone: string): Moment {
	const currentTimeString = moment().format("YYYY-MM-DD HH:mm:ss");
	const utc = zonedTimeToUtc(currentTimeString, timeZone);

	return moment(utc);
}

export function getZonedTime(time: string, timeZone: string): Moment {
	const utc = zonedTimeToUtc(time, timeZone);
	return moment(utc);
}
